import React from "react";

const EducationSystem = () => {
  return (
    <div className="p-6 md:p-12 max-w-4xl mx-auto bg-white rounded-xl shadow-sm mt-8 mb-12">
      <h2 className="text-3xl font-bold text-gray-800 mb-6 text-center leading-snug">
        NATIONAL MOVEMENT AGAINST CORRUPTION IN THE EDUCATION SYSTEM
      </h2>
      <div className="text-center mb-8">
        <p className="text-lg font-semibold text-blue-800">Led by Dr. Vikas Pandey</p>
        <p className="text-md text-gray-600">National President, CRC Bharat</p>
      </div>

      <div className="space-y-6 text-gray-700 leading-relaxed">
        <p>
          The Consumer Rights Council (CRC Bharat) has launched a nationwide movement against corruption and unhealthy practices in the education system. This initiative seeks to safeguard students' rights, reduce academic pressure, and promote a fair, transparent, and child-friendly educational environment across India.
        </p>

        <h3 className="text-2xl font-bold text-gray-800 mt-8 mb-4 border-b pb-2">Our Key Demands</h3>
        
        <div className="space-y-4">
          <div>
            <h4 className="text-lg font-bold text-gray-800">1. Limit School Timings to 6 Hours Per Day</h4>
            <p>Children deserve a healthy balance between academics, recreation, family life, and personal development. School timings should not exceed six hours per day.</p>
          </div>
          <div>
            <h4 className="text-lg font-bold text-gray-800">2. Ban IIT, NEET, and Medical Foundation Programs up to Class 10</h4>
            <p>Young students should be allowed to enjoy their childhood and receive holistic school education without the burden of competitive examination coaching at an early age.</p>
          </div>
          <div>
            <h4 className="text-lg font-bold text-gray-800">3. Ensure Equal Education Rights for All</h4>
            <p>Every child, regardless of social or economic background, must have equal access to quality education and equal opportunities to succeed.</p>
          </div>
          <div>
            <h4 className="text-lg font-bold text-gray-800">4. Stop the Sale of Unnecessary Books</h4>
            <p>Schools should strictly follow NCERT textbooks and avoid compelling parents to purchase expensive and unnecessary books from private publishers.</p>
          </div>
        </div>

        <h3 className="text-2xl font-bold text-gray-800 mt-8 mb-4 border-b pb-2">Why This Movement Matters</h3>
        <p>
          The education system should nurture knowledge, creativity, values, and overall personality development. Unfortunately, increasing commercialization, excessive academic pressure, and unfair practices are negatively affecting students and families.
        </p>
        <p className="font-semibold text-blue-800">
          CRC Bharat believes that education should empower children, not burden them.
        </p>

        <h3 className="text-2xl font-bold text-gray-800 mt-8 mb-4 border-b pb-2">Join the Movement</h3>
        <p>
          We invite parents, students, teachers, educationists, policymakers, and concerned citizens to support this national movement and work together for meaningful reforms in the education sector.
        </p>
        <p className="font-semibold italic">Save Childhood. Reform Education. Build India's Future.</p>

        <div className="bg-blue-50 p-6 rounded-lg mt-8 text-center border border-blue-100">
          <h4 className="font-bold text-xl text-gray-800 mb-2">Consumer Rights Council (CRC Bharat)</h4>
          <p className="text-gray-700 font-medium mb-4">National Movement Against Corruption in Education</p>
          <p className="text-gray-600 mb-1">For support and participation:</p>
          <p className="text-blue-600 font-medium">Website: <a href="http://www.crcbharat.com" className="hover:underline">www.crcbharat.com</a></p>
          <p className="text-green-600 font-medium">WhatsApp: <a href="https://wa.me/919963633653" className="hover:underline">+91 99636 33653</a></p>
        </div>

        <h3 className="text-2xl font-bold text-gray-800 mt-10 mb-4 border-b pb-2">SUPPORT THE MOVEMENT</h3>
        <p>
          CRC Bharat calls upon every responsible citizen to stand together for the future of our country. This movement is not just an initiative—it is a collective effort to protect childhood, improve the education system, and ensure a fair and transparent academic environment for all students.
        </p>
        <p>
          We request parents, students, teachers, educationists, and all well-wishers to extend their wholehearted support to this national movement against corruption and unhealthy practices in the education system.
        </p>

        <h4 className="text-xl font-bold text-gray-800 mt-6 mb-2">Your Support Matters</h4>
        <p>
          Every voice and every contribution strengthens this mission. Together, we can bring meaningful reform and create a better future for the next generation.
        </p>

        <h4 className="text-xl font-bold text-gray-800 mt-6 mb-2">Donate & Support</h4>
        <p>
          If you wish to contribute financially to support this movement, you can do so through our official donation page:
        </p>
        <p className="font-semibold text-lg my-4 text-center">
          👉 Donate Here: <a href="/donate" className="text-blue-600 hover:underline">www.crcbharat.com/donate</a>
        </p>
        <p>
          Your contribution will help in awareness campaigns, legal support activities, public meetings, and nationwide outreach programs.
        </p>

        <h4 className="text-xl font-bold text-gray-800 mt-6 mb-2">Join Hands for Change</h4>
        <p>
          Let us unite to protect students’ rights and build an education system based on equality, transparency, and holistic development.
        </p>
        <p className="text-center font-bold text-blue-900 mt-8 text-xl">
          Save Childhood. Reform Education. Strengthen the Nation.
        </p>
      </div>
    </div>
  );
};

export default EducationSystem;
